export enum errorType {
  minlength = 'minlength',
  maxlength = 'maxlength',
  required = 'required',
  pattern = 'pattern'
}

export enum inputsName {
  requiredEmailEmployee = 'requiredEmailEmployee',
  requiredPhoneEmployee = 'requiredPhoneEmployee',
  requiredHouseNumber = 'requiredHouseNumber'
}
